import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useState } from "react";
import {
  createEvidenceOfLearningByLcIdAndLevelId as createEvidenceOfLearningByLcIdAndLevelIdService,
  deleteEvidenceOfLearning as deleteEvidenceOfLearningService,
} from "../../services/maestro/evidence-of-learning.service.js";
import { handlerErrorV2 } from "../../utils/errors.jsx";
import { toggleAlertModule } from "../../store/actions/alert.actions.js";
import useMarking from "./useMarking.js";

const useEvidenceOfLearning = () => {
  const { curriculumId } = useParams();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const student = useSelector((state) => state?.classMarking?.student);
  const {
    getStudentMarkingByClassIdAndUlId
  } = useMarking();

  const onUpdateFormData = () => {
    getStudentMarkingByClassIdAndUlId(student);
  };

  const formData = (form) => {
    return {
      comment: form.comment,
      media: form.media
    }
  };
  const createEvidenceOfLearningByLcIdAndLevelId = async (studentId, lcId, levelId, form = {}) => {
    try {
      const data = formData(form);
      const response = await createEvidenceOfLearningByLcIdAndLevelIdService(
        curriculumId,
        studentId,
        lcId,
        levelId,
        data
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        dispatch(toggleAlertModule());
        onUpdateFormData();
        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    }
  };

  const deleteEvidenceOfLearning = async (studentId, evidenceOfLearningId) => {
    setIsLoading(true);
    try {
      const response = await deleteEvidenceOfLearningService(
        curriculumId,
        studentId,
        evidenceOfLearningId
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        onUpdateFormData();
        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    createEvidenceOfLearningByLcIdAndLevelId,
    deleteEvidenceOfLearning,
  };
};

export default useEvidenceOfLearning;
